const isHiddenProperty = (property: string, elementSchema: any = {}) => {
    return elementSchema.hidden?.includes(property);
};
export const sortPropertiesByOrder = (
    properties = {},
    order: string[] = [],
    isIncluded: (property: string) => boolean
) => {
    return order.reduce((obj, key) => {
        if (isIncluded(key) && properties[key] !== undefined) {
            obj[key] = properties[key];
        }
        return obj;
    }, {});
};
export const sortPropertiesByName = (
    properties = {},
    order: string[] = [],
    isIncluded: (property: string) => boolean
) => {
    return Object.keys(properties)
        .sort()
        .reduce((obj, key) => {
            if (!order.includes(key) && properties[key] !== undefined && isIncluded(key)) {
                obj[key] = properties[key];
            }
            return obj;
        }, {});
};
export const getShownAndHiddenProperties = (elementSchema: any) => {
    const isPropertyHidden = (property: string) => isHiddenProperty(property, elementSchema);

    const shownProperties = {
        ...sortPropertiesByOrder(
            elementSchema.properties,
            elementSchema.order,
            (property) => !isPropertyHidden(property)
        ),
        ...sortPropertiesByName(
            elementSchema.properties,
            elementSchema.order,
            (property) => !isPropertyHidden(property)
        ),
    };

    const hiddenProperties = {
        ...sortPropertiesByOrder(elementSchema.properties, elementSchema.order, (property) =>
            isPropertyHidden(property)
        ),
        ...sortPropertiesByName(elementSchema.properties, elementSchema.order, (property) =>
            isPropertyHidden(property)
        ),
    };

    return { shownProperties, hiddenProperties };
};
